module.exports = __webpack_public_path__ + "static/img/050 2.0c720af7.jpg";